import React, { useState, useEffect } from "react";
import { RxCross1 } from "react-icons/rx";
// import CartImg from "../../Assets/Images/Cartitem.jpeg";
import CartItem from "../CartItem/CartItem.js";
// import AddressBox from "../AddressBox/AddressBox.js";
// import { ProductData } from "../../Data/productsData";
import { useDispatch, useSelector } from "react-redux";

import "./Cart.scss";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { setCartOpen } from "../../Redux/slices/appConfigSlice";

function Cart() {
  const dispatch = useDispatch();
  const { isCartOpen } = useSelector((state) => state.app);
  const { carts } = useSelector((state) => state.products);
  const { addresses, isAuthenticated } = useSelector((state) => state.user);
  // const [secondComp, setSecondComp] = useState(false);
  // const [title, setTitle] = useState("");
  // const [name, setName] = useState("");
  // const [HNo, setHNO] = useState("");
  // const [address, setAddress] = useState("");
  // const [addressContainer, setAddressContainer] = useState(false);
  const navigate = useNavigate();

  const cartTotal = () => {
    return carts?.reduce(function (total, item) {
      return total + (item.quantity || 1) * item.price;
    }, 0);
  };

  // CLOSE CART
  useEffect(() => {
    const handleOutsideClick = (event) => {
      const cartElement = document.querySelector(".Cart");
      if (cartElement && !cartElement.contains(event.target)) {
        dispatch(setCartOpen(false));
      }
    };

    const handlePageUnload = () => {
      dispatch(setCartOpen(false));
    };

    document.addEventListener("mousedown", handleOutsideClick);
    window.addEventListener("beforeunload", handlePageUnload);
  }, []);

  const checkoutHandler = () => {
    if (isAuthenticated) {
      dispatch(setCartOpen(false));
      navigate("/checkout");
    } else {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "You Need To Login To Proceed Further",
      });
      dispatch(setCartOpen(false));
      navigate("/auth");
    }
    // navigate("/auth?redirect=checkout")
  };

  // const handleAddressOpener = () => {
  //   setAddressContainer(true);
  // };

  const handleClearCart = () => {
    dispatch({
      type: "ProductSlice/clearCart",
    });
  };

  // const handleCreateAddress = () => {
  //   dispatch({
  //     type: "user/createAddress",
  //     payload: { title, name, HNO: HNo, address },
  //   });

  //   setName("");
  //   setAddress("");
  //   setHNO("");
  //   setTitle("");
  //   setAddressContainer(false);
  // };

  return (
    <>
      {/* {addressContainer && (
        <div className="overlay">
          <RxCross1 onClick={() => setAddressContainer(false)} />
          <div className="Address__Box">
            <div className="top__box">
              <h3>Enter Complete Address</h3>
              <p className="p-text">
                This Allow us to find you easily and give you timely <br />
                Delivery exprerience
              </p>
            </div>

            <div className="form">
              <div className="cost__name">
                <select onChange={(e) => setTitle(e.target.value)}>
                  <option>MR</option>
                  <option>Miss</option>
                </select>
                <input
                  type="text"
                  onChange={(e) => setName(e.target.value)}
                  placeholder="Reciever's Name"
                />
              </div>

              <div className="address">
                <input
                  type="text"
                  onChange={(e) => setHNO(e.target.value)}
                  placeholder="Flat/House/Office No."
                />
              </div>

              <div className="address">
                <input
                  type="text"
                  onChange={(e) => setAddress(e.target.value)}
                  placeholder="Street/Society/Office Name"
                />
              </div>

              <button className="btn" onClick={handleCreateAddress}>
                Save Address
              </button>
            </div>
          </div>
        </div>
      )} */}
      <div className={`Cart flex__center ${isCartOpen ? "active" : ""}`}>
        <div className="top__cart-section">
          <h5>Welcome to Cart</h5>
          <RxCross1 onClick={() => dispatch(setCartOpen(false))} />
        </div>

        <div className="cart__del-info">
          <div className="left__info">
            <h5>My Cart</h5>
            <p className="p-text">{carts.length} Items</p>
          </div>

          <div className="right__opt">
            <button
              onClick={() => handleClearCart()}
              className="theme-btn-one btn-black-overlay btn_sm"
            >
              Clear Cart
            </button>
          </div>
        </div>

        <div className="item__container">
          {carts.map((product, index) => (
            <CartItem
              id={product._id}
              name={product.name}
              imgUrl={product.images[0].url}
              price={product.price}
              quantity={product.quantity}
              weight={product.weight}
            />
          ))}
        </div>

        <div onClick={checkoutHandler} className="place__order">
          <h5>
            {carts.length} Items . {cartTotal()}
          </h5>
          <h5>CheckOut</h5>
        </div>
      </div>

      {/* {secondComp && (
        <div className={`Cart flex__center ${isCartOpen ? "active" : ""}`}>
          <div className="top__cart-section">
            <h5>My Address</h5>
            <RxCross1 onClick={() => dispatch(setCartOpen(false))} />
          </div>
          <div className="address comp2">
            <span onClick={handleAddressOpener}>+</span>
            <div className="add__adress">
              <h5>Add A New Address</h5>
            </div>
          </div>
          <div className="address__selection">
            <p className="p-text">Choose Delivery Address</p>

            <div className="address__selection-container">
              {addresses?.map((info, index) => (
                <AddressBox
                  key={index - info.HNO}
                  name={info.name}
                  HNO={info.HNO}
                  title={info.title}
                  address={info.address}
                />
              ))}
            </div>
          </div>

          <div onClick={handleChangeComp} className="place__order submit">
            <h5>Back to Cart</h5>
          </div>
        </div>
      )} */}
    </>
  );
}

export default Cart;
